// frontend/src/pages/storeActivity/PagesPanel.jsx
//
// Where people go: page views per route.
// Page views are purged on a shorter window than the rest of the events, so
// the subtitle says how much history this is; the number comes from the
// backend so the copy cannot drift from the window the purge enforces.

import React from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ICON, CursorClick } from '../../icons';
import { useFormatters } from '../../hooks/useFormatters';
import { Panel } from './primitives';
import { EMPTY } from './text';

export default function PagesPanel({ pages, windowDays }) {
  const { t } = useTranslation();
  return (
    <Panel
      icon={<CursorClick size={ICON.md} />}
      title={t('storeActivity.pagesPanel.title')}
      subtitle={t('storeActivity.pagesPanel.subtitle', { count: windowDays })}
    >
      <BarList rows={pages} />
    </Panel>
  );
}

function BarList({ rows }) {
  const { t } = useTranslation();
  const { formatNumber } = useFormatters();
  if (rows.length === 0) return <div className="sa-panel-empty">{t('storeActivity.empty.pages')}</div>;
  const max = Math.max(...rows.map((r) => r.views), 1);
  return (
    <div>
      {rows.map((r, i) => (
        <div className="sa-bar" key={i}>
          <div className="sa-bar-top">
            <Tooltip title={r.path} describeChild>
              <span className="sa-bar-path">{r.path ? r.path : EMPTY}</span>
            </Tooltip>
            <span className="sa-bar-count">{formatNumber(r.views, 0)}</span>
          </div>
          <div className="sa-bar-track">
            <div className="sa-bar-fill" style={{ width: `${(r.views / max) * 100}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
